<footer class="footer">
  <div class="footer-container">
    <div class="footer-section">
      <div class='brand'><img src='assets/images/logo.png' alt="Hindustan Antibiotics Limited" /></div>
      <div class="tagline">Hindustan Antibiotics Limited</div>
    </div>

    <div class="footer-section">
      <h4>Products</h4>
      <ul>
        <li><a href="#">Health Box</a></li>
      </ul>
    </div>

    <div class="footer-section">
      <h4>Solutions</h4>
      <ul>
        <li><a href="#">AI Analysis</a></li>
        <li><a href="#">Data Insights</a></li>
      </ul>
    </div>

    <div class="footer-section contact">
      <h4>Contact Us</h4>
      <p>+91 11111 11111</p>
      <p><a href="mailto:support@healthbox.com">support&#64;healthbox.com</a></p>
      <p>Healthbox Technologies Pvt. Ltd.<br>
        Address, Pune, India</p>
    </div>

    <div class="footer-section social">
      <h4>Social Media</h4>
      <div class="social-icons">
        <svg cIcon name="cibLinkedin"></svg>
        <svg cIcon name="cibFacebook"></svg>
        <svg cIcon name="cibInstagram"></svg>
        <svg cIcon name="cibTwitter"></svg>
        <svg cIcon name="cibYoutube"></svg>
      </div>
    </div>
  </div>
</footer>